module.exports = __webpack_public_path__ + "img/7bombas.0aada973.jpg";